import React from 'react';

import CheckboxInput from 'components/input/CheckboxInput';
import { useTranslation } from 'react-i18next';
import { PRIVACY_POLICY_URL, TERMS_OF_SERVICE_URL } from 'shared/constants';

export type SignupConsentValues = {
  terms: boolean;
  privacy: boolean;
  marketing: boolean;
};

type SignupConsentsProps = {
  value: SignupConsentValues;
  onChange: (value: SignupConsentValues) => void;
  className?: string;
};

export const INITIAL_SIGNUP_CONSENTS: SignupConsentValues = { terms: false, privacy: false, marketing: false };

export const hasRequiredSignupConsents = ({ terms, privacy }: SignupConsentValues) => terms && privacy;

/** 가입 약관 동의 (전체 동의 + 이용약관·개인정보 필수 + 마케팅 선택) — 이메일 가입 4단계와 온보딩 공용 */
const SignupConsents = ({ value, onChange, className = '' }: SignupConsentsProps) => {
  const { t } = useTranslation('auth');
  const isAllAgreed = value.terms && value.privacy && value.marketing;

  const openLink = (e: React.MouseEvent, url: string) => {
    e.stopPropagation();
    window.open(url, '_blank');
  };

  return (
    <div className={`flex w-full flex-col gap-y-2 text-[12px] text-gray-40 md:text-c1 ${className}`}>
      <CheckboxInput
        checked={isAllAgreed}
        setChecked={(checked) => onChange({ terms: checked, privacy: checked, marketing: checked })}
        className="w-full border-b border-gray-20 pb-2 font-semibold text-[#222]"
      >
        {t('signup.step4.agreeAll')}
      </CheckboxInput>
      <CheckboxInput checked={value.terms} setChecked={(terms) => onChange({ ...value, terms })}>
        {t('signup.step4.termsAgree')}{' '}
        <span
          className="underline underline-offset-2 hover:text-black"
          onClick={(e) => openLink(e, TERMS_OF_SERVICE_URL)}
        >
          {t('signup.step4.termsAgreeLink')}
        </span>
      </CheckboxInput>
      <CheckboxInput checked={value.privacy} setChecked={(privacy) => onChange({ ...value, privacy })}>
        {t('signup.step4.privacyAgree')}{' '}
        <span
          className="underline underline-offset-2 hover:text-black"
          onClick={(e) => openLink(e, PRIVACY_POLICY_URL)}
        >
          {t('signup.step4.privacyAgreeLink')}
        </span>
      </CheckboxInput>
      <CheckboxInput checked={value.marketing} setChecked={(marketing) => onChange({ ...value, marketing })}>
        {t('signup.step4.marketingAgree')}
      </CheckboxInput>
    </div>
  );
};

export default SignupConsents;
